const TextArea = ({ label = "máx. 1,000 caracteres", placeholder = "", errorMessage = "", onChange = () => { }, isValid = true, ...rest }) => {
    const handelChange = (e) => {
        e.target.classList.remove("input-error")

        onChange(e);
    }

    return (
        <div className="">
            <textarea
                className="form-control cs-input in-textarea"
                maxLength="10000"
                placeholder={placeholder}
                rows="3"
                onChange={handelChange}
                {...rest}
            ></textarea>
            <span className="cs-input-label">{label}</span>
            {!isValid && <span className="cs-input-border">{errorMessage}</span>}
        </div>
    );
}

export default TextArea;